import { createSelector } from 'reselect';
import { Map, List } from 'immutable';

import { denormalizeModelList } from 'reducers/utils/Normalizer';

const selectFundingEnquiry = (state) => state.get('fundingEnquiry');

const makeSelectById = () =>
  createSelector(selectFundingEnquiry, (state) => state.get('byId', Map()));

const makeSelectAll = () =>
  createSelector(selectFundingEnquiry, (state) => state.get('list', Map()));

const makeSelectAllList = () =>
  createSelector(makeSelectById(), makeSelectAll(), (byId, state) =>
    denormalizeModelList(byId, state.get('ids', List())),
  );

const makeSelectAllLoading = () =>
  createSelector(makeSelectAll(), (state) => state.getIn(['network', 'loading']));

const makeSelectAllError = () =>
  createSelector(makeSelectAll(), (state) => state.getIn(['network', 'error']));

export { makeSelectAll, makeSelectAllList, makeSelectAllLoading, makeSelectAllError };
